import { Component, Input, OnInit } from '@angular/core';

import { CvService } from '../../services/cv.service';
import { ProfileChangesService } from '../../services/profile-changes.service';

@Component({
  selector: 'bwc-profile-visibility',
  templateUrl: './profile-visibility.component.html',
  styleUrls: ['./profile-visibility.component.scss'],
})
export class ProfileVisibilityComponent implements OnInit {
  visibleToEmployers = false;
  loading = true;
  @Input() accountActivated: boolean = false;

  constructor(private cvService: CvService, private profileChangesService: ProfileChangesService) {}

  ngOnInit(): void {
    this.cvService.getCV().subscribe({
      next: (cv) => {
        this.visibleToEmployers = cv.visible_to_employers ?? false;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  toggleVisibility(): void {
    this.visibleToEmployers = !this.visibleToEmployers;
    this.profileChangesService.setVisibility(this.visibleToEmployers);
  }
}
